import { WorkFlowService } from "../../services/workflow-service";
import { managedBindingWorkflowFromDto, type IManagedBindingWorkflowLike } from "./managed-screen-binding-sources";

/**
 * The workflow behind a managed task screen, fetched with its `json` (and
 * therefore its parameters).
 *
 * Shared by BOTH halves of the binding surface (KOA-18136): the inventory read,
 * which would otherwise present a list missing the workflow's own parameters as
 * if it were complete, and the binding write, which would otherwise refuse those
 * same parameters. Designer state cannot answer for either — `projectsWithWFData`
 * is filled by three property panels, `workFlowList` holds list DTOs with no
 * parameters, and `selectedWf` exists only while the modeler holds the process.
 *
 * Best-effort by design: a failed fetch is reported by the caller (an incomplete
 * inventory says so; a refused write stays refused), never smoothed over.
 */
export async function fetchManagedScreenWorkflow(processId: string): Promise<IManagedBindingWorkflowLike | undefined> {
  try {
    const response = await WorkFlowService.Get(processId);
    if (response?.status !== 200) return undefined;
    return managedBindingWorkflowFromDto(response.data);
  } catch {
    return undefined;
  }
}
